import { CheckIcon } from "@chakra-ui/icons";
import {
  IconButton,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getAddAnswerData,
  setContent,
  setIsCorrect,
} from "redux/slices/addAnswerSlice";
//import { getAddQuestionData, setFiles, setName } from "redux/slices/AddQuestionSlice"

interface AddAnswerProps {
  addOrUpdate: "ADD" | "UPDATE";
  submitHandler?: (e: React.FormEvent) => void;
  questionId: number;
  updateHandler?: (e: React.FormEvent) => void;
}
const AddAnswer: React.FC<AddAnswerProps> = ({
  submitHandler,
  addOrUpdate,
  updateHandler,
}: AddAnswerProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [value, setValue] = React.useState("1");
  const { content, isCorrect, answers } = useAppSelector(getAddAnswerData);
  const dispatch = useAppDispatch();
  //const {content} = useAppSelector(getAddQuestionData)
  return (
    <>
      <VStack>
        <Input
          value={content}
          onChange={(e) => dispatch(setContent(e.target.value))}
          placeholder="Contenu de réponse"
          borderRadius={"full"}
          type="text"
        />
        <Text>Réponse correcte?</Text>
        <RadioGroup
          colorScheme={"brand"}
          onChange={(val) => dispatch(setIsCorrect(val))}
          value={isCorrect}
        >
          <Stack direction="row">
            <Radio value="1">Oui</Radio>
            <Radio value="2">Non</Radio>
          </Stack>
        </RadioGroup>
      </VStack>
      <IconButton
        aria-label=""
        onClick={addOrUpdate === "ADD" ? submitHandler : updateHandler}
        icon={<CheckIcon />}
      />
    </>
  );
};
export default AddAnswer;
